export const isEmpty = (obj) => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
};


export const getCurrentEnv = () => {
   if (isProd) {
        return 'production';
    } else if (isLocalhost || isDebugMode) {
        return 'localhost';
    } else {
        return undefined;
    }
};

export const isLocalhost = document.location.hostname === 'localhost';
export const isDebugMode = document.location?.host === 'localhost:3000';
export const isDev = /dev.fishipedia.fr/.test(document.location.href);
export const isProd = /www.fishipedia.fr/.test(document.location.href);
